


// import React, { useState } from 'react';
// import { motion } from 'framer-motion';
// import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Area, ComposedChart } from 'recharts';
// import CalculatorForm from './CalculatorForm';

// const DigitalCalculator = () => {
//   const [monthlyInvestment, setMonthlyInvestment] = useState(25000);
//   const [timePeriod, setTimePeriod] = useState(20);
//   const [expectedReturn, setExpectedReturn] = useState(12);
//   const [result, setResult] = useState(null);
//   const [chartData, setChartData] = useState([]);
//   const [showForm, setShowForm] = useState(false);

//   const calculate = () => {
//     const monthlyRate = expectedReturn / 12 / 100;
//     const months = timePeriod * 12;
//     const futureValue = monthlyInvestment * ((Math.pow(1 + monthlyRate, months) - 1) / monthlyRate) * (1 + monthlyRate);
//     const totalInvestment = monthlyInvestment * months;
//     const estimatedReturns = futureValue - totalInvestment;
    
//     const data = [];
//     let runningTotal = 0;
//     let totalInvestedSoFar = 0;
    
//     for (let month = 1; month <= months; month++) {
//       totalInvestedSoFar += monthlyInvestment;
//       runningTotal = (runningTotal + monthlyInvestment) * (1 + monthlyRate);
      
//       if (month % 12 === 0 || month === months) {
//         data.push({
//           year: month / 12,
//           invested: totalInvestedSoFar,
//           value: runningTotal,
//           returns: runningTotal - totalInvestedSoFar
//         });
//       }
//     }
    
//     setResult({ futureValue, totalInvestment, estimatedReturns });
//     setChartData(data);
//   };

//   const handleDownloadReport = () => {
//     setShowForm(true);
//   };

//   const handleFormSubmit = (userData) => {
//     setShowForm(false);
//     const whatsappMessage = `Dear ${userData.name},\n\n📊 Investment Summary:\n\n• Monthly Investment: ₹${monthlyInvestment.toLocaleString()}\n• Time Period: ${timePeriod} years\n• Expected Return: ${expectedReturn}% p.a.\n• Total Investment: ₹${result.totalInvestment.toLocaleString()}\n• Estimated Returns: ₹${result.estimatedReturns.toLocaleString()}\n• Future Value: ₹${result.futureValue.toLocaleString()}\n\n- Wisdom Consultancy`;
//     window.open(`https://wa.me/${userData.phone}?text=${encodeURIComponent(whatsappMessage)}`, '_blank');
//   };

//   const CustomTooltip = ({ active, payload, label }) => {
//     if (active && payload && payload.length) {
//       return (
//         <div className="bg-white p-4 rounded-lg shadow-lg border border-gray-200">
//           <p className="font-bold text-primary mb-2">Year {label}</p>
//           <p className="text-sm text-gray-600">Invested: <span className="font-semibold text-primary">₹{payload[0]?.value?.toLocaleString()}</span></p>
//           <p className="text-sm text-gray-600">Portfolio Value: <span className="font-semibold text-green-600">₹{payload[1]?.value?.toLocaleString()}</span></p>
//           <p className="text-sm text-gray-600">Returns: <span className="font-semibold text-accent">+₹{(payload[1]?.value - payload[0]?.value).toLocaleString()}</span></p>
//         </div>
//       );
//     }
//     return null;
//   };

//   return (
//     <div className="bg-white rounded-2xl shadow-2xl overflow-hidden">
//       <div className="grid lg:grid-cols-2">
//         <div className="p-8 bg-gradient-to-br from-gray-50 to-white">
//           <h3 className="text-2xl font-bold text-primary mb-6">Investment Calculator</h3>
          
//           <div className="space-y-6">
//             <div>
//               <label className="block text-gray-700 font-semibold mb-2">Monthly Investment (₹)</label>
//               <input
//                 type="range"
//                 min="1000"
//                 max="100000"
//                 step="1000"
//                 value={monthlyInvestment}
//                 onChange={(e) => setMonthlyInvestment(Number(e.target.value))}
//                 className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-primary"
//               />
//               <div className="flex justify-between mt-2">
//                 <span className="text-sm text-gray-500">₹1,000</span>
//                 <span className="font-bold text-primary text-lg">₹{monthlyInvestment.toLocaleString()}</span>
//                 <span className="text-sm text-gray-500">₹1,00,000</span>
//               </div>
//             </div>

//             <div>
//               <label className="block text-gray-700 font-semibold mb-2">Time Period (Years)</label>
//               <input
//                 type="range"
//                 min="1"
//                 max="40"
//                 value={timePeriod}
//                 onChange={(e) => setTimePeriod(Number(e.target.value))}
//                 className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-primary"
//               />
//               <div className="flex justify-between mt-2">
//                 <span className="text-sm text-gray-500">1 Year</span>
//                 <span className="font-bold text-primary text-lg">{timePeriod} Years</span>
//                 <span className="text-sm text-gray-500">40 Years</span>
//               </div>
//             </div>

//             <div>
//               <label className="block text-gray-700 font-semibold mb-2">Expected Return (% p.a.)</label>
//               <input
//                 type="range"
//                 min="4"
//                 max="20"
//                 step="0.5"
//                 value={expectedReturn}
//                 onChange={(e) => setExpectedReturn(Number(e.target.value))}
//                 className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-primary"
//               />
//               <div className="flex justify-between mt-2">
//                 <span className="text-sm text-gray-500">4%</span>
//                 <span className="font-bold text-primary text-lg">{expectedReturn}%</span>
//                 <span className="text-sm text-gray-500">20%</span>
//               </div>
//             </div>

//             <button onClick={calculate} className="w-full btn-secondary py-3 text-lg">
//               Calculate Now
//             </button>
//           </div>
//         </div>

//         <div className="p-8 bg-gradient-hero text-white">
//           <h3 className="text-2xl font-bold mb-6">Estimated Future Value</h3>
          
//           {result ? (
//             <motion.div
//               key={result.futureValue}
//               initial={{ scale: 0.9, opacity: 0 }}
//               animate={{ scale: 1, opacity: 1 }}
//               transition={{ duration: 0.3 }}
//               className="mb-8"
//             >
//               <p className="text-4xl md:text-5xl font-bold mb-2">₹{Math.round(result.futureValue).toLocaleString()}</p>
//               <div className="border-t border-white/30 my-4"></div>
//               <div className="flex justify-between text-sm">
//                 <span>Total Amount Invested:</span>
//                 <span className="font-semibold">₹{Math.round(result.totalInvestment).toLocaleString()}</span>
//               </div>
//               <div className="flex justify-between text-sm mt-2">
//                 <span>Estimated Returns:</span>
//                 <span className="font-semibold text-accent">+ ₹{Math.round(result.estimatedReturns).toLocaleString()}</span>
//               </div>
//             </motion.div>
//           ) : (
//             <div className="mb-8 text-center">
//               <p className="text-gray-300">Click "Calculate Now" to see your investment growth</p>
//             </div>
//           )}
          
//           <button 
//             onClick={handleDownloadReport}
//             disabled={!result}
//             className={`w-full py-3 rounded-lg font-semibold transition-all ${result ? 'bg-accent text-white hover:bg-opacity-90' : 'bg-gray-400 text-gray-200 cursor-not-allowed'}`}
//           >
//             Download Report
//           </button>
//           <p className="text-xs text-center mt-4 opacity-75">*These are estimated values for illustration purposes.</p>
//         </div>
//       </div>

//       {result && chartData.length > 0 && (
//         <motion.div 
//           initial={{ opacity: 0, y: 20 }}
//           animate={{ opacity: 1, y: 0 }}
//           className="p-8 border-t border-gray-200 bg-white"
//         >
//           <h3 className="text-xl font-bold text-primary mb-6 text-center">Growth Projection Over Time</h3>
//           <div className="h-96">
//             <ResponsiveContainer width="100%" height="100%">
//               <ComposedChart data={chartData}>
//                 <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
//                 <XAxis dataKey="year" label={{ value: 'Years', position: 'bottom' }} tick={{ fill: '#6b7280' }} />
//                 <YAxis label={{ value: 'Amount (₹)', angle: -90, position: 'left' }} tickFormatter={(value) => `₹${(value / 100000).toFixed(0)}L`} tick={{ fill: '#6b7280' }} />
//                 <Tooltip content={<CustomTooltip />} />
//                 <Legend verticalAlign="top" height={36} />
//                 <Area type="monotone" dataKey="invested" stackId="1" stroke="#8884d8" fill="#8884d8" fillOpacity={0.3} name="Total Invested" />
//                 <Area type="monotone" dataKey="value" stackId="2" stroke="#82ca9d" fill="#82ca9d" fillOpacity={0.3} name="Portfolio Value" />
//                 <Line type="monotone" dataKey="value" stroke="#e67e22" strokeWidth={3} dot={{ r: 4, fill: "#e67e22" }} activeDot={{ r: 6 }} name="Growth Line" />
//               </ComposedChart>
//             </ResponsiveContainer>
//           </div>
          
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-6">
//             <div className="bg-blue-50 rounded-lg p-4 text-center">
//               <p className="text-sm text-gray-600">Total Investment</p>
//               <p className="text-xl font-bold text-primary">₹{Math.round(result.totalInvestment).toLocaleString()}</p>
//             </div>
//             <div className="bg-green-50 rounded-lg p-4 text-center">
//               <p className="text-sm text-gray-600">Total Returns</p>
//               <p className="text-xl font-bold text-green-600">+₹{Math.round(result.estimatedReturns).toLocaleString()}</p>
//             </div>
//             <div className="bg-orange-50 rounded-lg p-4 text-center">
//               <p className="text-sm text-gray-600">Final Corpus</p>
//               <p className="text-xl font-bold text-accent">₹{Math.round(result.futureValue).toLocaleString()}</p>
//             </div>
//           </div>
//         </motion.div>
//       )}

//       {showForm && <CalculatorForm onSubmit={handleFormSubmit} onClose={() => setShowForm(false)} calculatorType="Investment" />}
//     </div>
//   );
// };

// export default DigitalCalculator;

import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Area, ComposedChart } from 'recharts';
import CalculatorForm from './CalculatorForm';

const DigitalCalculator = () => {
  const [monthlyInvestment, setMonthlyInvestment] = useState(25000);
  const [timePeriod, setTimePeriod] = useState(20);
  const [expectedReturn, setExpectedReturn] = useState(12);
  const [result, setResult] = useState(null);
  const [chartData, setChartData] = useState([]);
  const [showForm, setShowForm] = useState(false);

  const calculate = () => {
    const monthlyRate = expectedReturn / 12 / 100;
    const months = timePeriod * 12;
    const futureValue = monthlyInvestment * ((Math.pow(1 + monthlyRate, months) - 1) / monthlyRate) * (1 + monthlyRate);
    const totalInvestment = monthlyInvestment * months;
    const estimatedReturns = futureValue - totalInvestment;
    
    const data = [];
    let runningTotal = 0;
    let totalInvestedSoFar = 0;
    
    for (let month = 1; month <= months; month++) {
      totalInvestedSoFar += monthlyInvestment;
      runningTotal = (runningTotal + monthlyInvestment) * (1 + monthlyRate);
      
      if (month % 12 === 0 || month === months) {
        data.push({
          year: month / 12,
          invested: totalInvestedSoFar,
          value: runningTotal,
          returns: runningTotal - totalInvestedSoFar
        });
      }
    }
    
    setResult({ futureValue, totalInvestment, estimatedReturns });
    setChartData(data);
  };

  const handleDownloadReport = () => {
    setShowForm(true);
  };

  const handleFormSubmit = (userData) => {
    setShowForm(false);
    const whatsappMessage = `Dear ${userData.name},\n\n📊 Investment Summary:\n\n• Monthly Investment: ₹${monthlyInvestment.toLocaleString()}\n• Time Period: ${timePeriod} years\n• Expected Return: ${expectedReturn}% p.a.\n• Total Investment: ₹${result.totalInvestment.toLocaleString()}\n• Estimated Returns: ₹${result.estimatedReturns.toLocaleString()}\n• Future Value: ₹${result.futureValue.toLocaleString()}\n\n- Wisdom Consultancy`;
    window.open(`https://wa.me/${userData.phone}?text=${encodeURIComponent(whatsappMessage)}`, '_blank');
  };

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white p-3 rounded-lg shadow-lg border border-gray-200">
          <p className="font-bold text-gray-900 mb-1">Year {label}</p>
          <p className="text-sm text-gray-600">Invested: <span className="font-semibold text-gray-900">₹{payload[0]?.value?.toLocaleString()}</span></p>
          <p className="text-sm text-gray-600">Value: <span className="font-semibold text-green-600">₹{payload[1]?.value?.toLocaleString()}</span></p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
      <div className="grid lg:grid-cols-2">
        {/* Left side - Input Controls */}
        <div className="p-6 md:p-8">
          <h3 className="text-xl font-bold text-gray-900 mb-6">Investment Calculator</h3>
          
          <div className="space-y-6">
            <div>
              <label className="block text-gray-700 font-semibold mb-2">Monthly Investment (₹)</label>
              <input
                type="range"
                min="1000"
                max="100000"
                step="1000"
                value={monthlyInvestment}
                onChange={(e) => setMonthlyInvestment(Number(e.target.value))}
                className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-blue-600"
              />
              <div className="flex justify-between mt-2">
                <span className="text-sm text-gray-500">₹1,000</span>
                <span className="font-bold text-gray-900">₹{monthlyInvestment.toLocaleString()}</span>
                <span className="text-sm text-gray-500">₹1,00,000</span>
              </div>
            </div>

            <div>
              <label className="block text-gray-700 font-semibold mb-2">Time Period (Years)</label>
              <input
                type="range"
                min="1"
                max="40"
                value={timePeriod}
                onChange={(e) => setTimePeriod(Number(e.target.value))}
                className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-blue-600"
              />
              <div className="flex justify-between mt-2">
                <span className="text-sm text-gray-500">1 Year</span>
                <span className="font-bold text-gray-900">{timePeriod} Years</span>
                <span className="text-sm text-gray-500">40 Years</span>
              </div>
            </div>

            <div>
              <label className="block text-gray-700 font-semibold mb-2">Expected Return (% p.a.)</label>
              <input
                type="range"
                min="4"
                max="20"
                step="0.5"
                value={expectedReturn}
                onChange={(e) => setExpectedReturn(Number(e.target.value))}
                className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-blue-600"
              />
              <div className="flex justify-between mt-2">
                <span className="text-sm text-gray-500">4%</span>
                <span className="font-bold text-gray-900">{expectedReturn}%</span>
                <span className="text-sm text-gray-500">20%</span>
              </div>
            </div>

            <button 
              onClick={calculate}
              className="w-full bg-blue-600 text-white py-3 rounded-lg font-semibold hover:bg-blue-700 transition-all"
            >
              Calculate Now
            </button>
          </div>
        </div>

        {/* Right side - Results Display - FIXED */}
        <div className="p-6 md:p-8 bg-gray-50">
          <h3 className="text-xl font-bold text-gray-900 mb-6">Estimated Future Value</h3>
          
          {result ? (
            <motion.div
              key={result.futureValue}
              initial={{ scale: 0.95, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.3 }}
              className="text-center"
            >
              <p className="text-3xl md:text-4xl font-bold text-blue-600 mb-4">
                + ₹{Math.round(result.estimatedReturns).toLocaleString()}
              </p>
              <div className="border-t border-gray-200 my-4"></div>
              <div className="space-y-2 text-left">
                <div className="flex justify-between">
                  <span className="text-gray-600">Total Investment:</span>
                  <span className="font-semibold text-gray-900">₹{Math.round(result.totalInvestment).toLocaleString()}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Future Value:</span>
                  <span className="font-semibold text-green-600">₹{Math.round(result.futureValue).toLocaleString()}</span>
                </div>
              </div>
            </motion.div>
          ) : (
            <div className="text-center py-8">
              <p className="text-gray-500">Click "Calculate Now" to see your investment growth</p>
              <div className="mt-4 text-5xl text-gray-300">📊</div>
            </div>
          )}
          
          <button 
            onClick={handleDownloadReport}
            disabled={!result}
            className={`w-full mt-6 py-3 rounded-lg font-semibold transition-all ${
              result 
                ? 'bg-green-600 text-white hover:bg-green-700' 
                : 'bg-gray-200 text-gray-400 cursor-not-allowed'
            }`}
          >
            Download Report
          </button>
          <p className="text-xs text-center text-gray-400 mt-4">*Estimated values for illustration</p>
        </div>
      </div>

      {/* Chart Section */}
      {result && chartData.length > 0 && (
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="p-6 border-t border-gray-100 bg-white"
        >
          <h3 className="text-lg font-bold text-gray-900 mb-4 text-center">Growth Projection Over Time</h3>
          <div className="h-80">
            <ResponsiveContainer width="100%" height="100%">
              <ComposedChart data={chartData}>
                <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
                <XAxis dataKey="year" label={{ value: 'Years', position: 'bottom' }} tick={{ fill: '#6b7280' }} />
                <YAxis label={{ value: 'Amount (₹)', angle: -90, position: 'left' }} tick={{ fill: '#6b7280' }} />
                <Tooltip content={<CustomTooltip />} />
                <Legend />
                <Area type="monotone" dataKey="invested" stackId="1" stroke="#8884d8" fill="#8884d8" fillOpacity={0.3} name="Total Invested" />
                <Area type="monotone" dataKey="value" stackId="2" stroke="#82ca9d" fill="#82ca9d" fillOpacity={0.3} name="Portfolio Value" />
                <Line type="monotone" dataKey="value" stroke="#2563eb" strokeWidth={2} dot={{ r: 3 }} name="Growth Line" />
              </ComposedChart>
            </ResponsiveContainer>
          </div>
        </motion.div>
      )}

      {showForm && <CalculatorForm onSubmit={handleFormSubmit} onClose={() => setShowForm(false)} calculatorType="Investment" />}
    </div>
  );
};

export default DigitalCalculator;